
import { Component, Mixins } from "vue-property-decorator";
import Enumerable from "linq";
import { Patient, Sex, Age } from "../../../../domain/patient";
import { DateFormatter } from "../../../../domain/system";

interface ISexInformation {
  sex: Sex;
  key: string;
  name: string;
}

@Component
export default class PatientViewerMixin extends Mixins() {
  patient: Patient;

  get isPatientEnable(): boolean {
    return !!this.patient;
  }

  protected formatBirthdayString(format: (b: string, a: string) => string): string {
    return this.format(p => format(this.toBirthdayString(p.birthday), this.toAgeString(p.age)));
  }

  protected format(format: (p: Patient) => string): string {
    return (this.patient && format)
      ? format(this.patient)
      : "";
  }

  get id(): string {
    return this.format(p => p.id);
  }

  get name(): string {
    return this.format(p => p.name);
  }

  get kanaName(): string {
    return this.format(p => p.kanaName);
  }

  get birthday(): string {
    return this.format(p => this.toBirthdayString(p.birthday));
  }

  private toBirthdayString(birthday: Date) {
    return birthday
      ? DateFormatter.format(birthday, "YYYY($JJJ$$Y$)年MM月DD日")
      : "誕生日不明";
  }

  get sex(): string {
    return this.format(p => this.toSexInfo(p.sex).name);
  }

  private toSexInfo(sex: Sex): ISexInformation {
    const result = Enumerable.from(PatientViewerMixin._sexes)
      .firstOrDefault(s => s.sex === sex);
    return result
      ? result
      : PatientViewerMixin._sexes[0];
  }

  private static readonly _sexes: ISexInformation[] = [
    {
      sex: Sex.Unknown,
      key: "Unknown",
      name: "性別不明",
    },
    {
      sex: Sex.Male,
      key: "Male",
      name: "男性",
    },
    {
      sex: Sex.Female,
      key: "Female",
      name: "女性",
    },
  ];

  get sexKey(): string {
    return this.format(p => this.toSexInfo(p.sex).key);
  }

  get age(): string {
    return this.format(p => this.toAgeString(p.age));
  }

  private toAgeString(age: Age) {
    return age
      ? age.year + "歳"
      : "年齢不明";
  }
}
